module.exports = __webpack_public_path__ + "img/22_13.7a488545.png";